import { render, staticRenderFns } from "./PRO_FindingSummaryCPT.vue?vue&type=template&id=37694fc2&scoped=true&"
import script from "./PRO_FindingSummaryCPT.vue?vue&type=script&lang=js&"
export * from "./PRO_FindingSummaryCPT.vue?vue&type=script&lang=js&"
import style0 from "./PRO_FindingSummaryCPT.vue?vue&type=style&index=0&id=37694fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37694fc2",
  null
  
)

export default component.exports